// extracted by mini-css-extract-plugin
export default {"Form":"gOTMb1GYKIJFlRyprdBe","Input":"TfVuevt1KBvmdwZJlJv_","Button":"WwD9GpGkjnHqxKVC3Z8d"};